import React, { useState, useEffect } from 'react';
import { Table, Tooltip } from 'antd';
import useAuth from '../hooks/useAuth';
import axiosInstance from '../utilities/axiosInstance';
import { showAlert } from "./AlertPopup";
import CustomListBox from "./CustomListBox";
import clsx from 'clsx';

const CompletedTaskData = () => {
  const [data, setData] = useState([]);
  const [reviewerList, setReviewerList] = useState([]);
  const [assignedTo, setAssignedTo] = useState("");
  const [isSubmitted, setIsSubmitted] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { auth } = useAuth();

  const getCompletedTasks = () => {
    axiosInstance
      .get(`/completedtasks`)
      .then(response => {
        setData(response.data)
      })
      .catch(error => console.error(error));
  }

  const getReviewers = () => {
    axiosInstance
      .get(`/getallreviewers`)
      .then(response => {
        setReviewerList(response.data)
      })
      .catch(error => console.error(error));
  }

  useEffect(() => {
    getCompletedTasks();
    getReviewers();
    setSelectedRowKeys([]);
  }, []);

  for (let i = 0; i < i.le; i++) {
    data.push({
      taskId: i,
      taskTitle: `task1 ${i}`,
      status: 'completed',
      creationDate: ` 5/6 ${i}`,
    });
  }
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;
  const handleTaskSubmit = () => {
    selectedRowKeys.forEach(key => {
      const selectedRow = data.find(row => row.task_id === key);
      if (selectedRow) {
        const updatedRow = { ...selectedRow };
        updatedRow.reviewer_profile_id = assignedTo;
        updatedRow.profile_role = 4;
        updatedRow.task_role = 4;
        updatedRow.task_status = "waiting for review";

        axiosInstance
          .put(`/updatetask/${selectedRow.task_id}`, {
            id: selectedRow.task_id,
            record: updatedRow
          })
          .then(response => {
            let temp = { ...isSubmitted };
            temp[response.data._id] = true;
            setIsSubmitted(temp);
            showAlert(response?.message, 'success');
          })
          .catch(error => console.error(error));
      }
    });
  };

  const columns = [
    {
      title: (
        <Tooltip title="Task ID">
          <span>Task</span>
        </Tooltip>
      ),
      dataIndex: 'task_id',
      key: 'taskId'
    },
    {
      title: (
        <Tooltip title="Task Title">
          <span>Title</span>
        </Tooltip>
      ),
      dataIndex: 'task_title',
      key: 'taskTitle'
    },
    {
      title: (
        <Tooltip title="Project Name">
          <span>Project</span>
        </Tooltip>
      ),
      dataIndex: 'project_name',
      key: 'projectName',
      render: (text, records) => {
        try {
          return (
            <a>{records.project_name}</a>
          )
        } catch (error) {
          console.error("Error rendering number of images:", error);
        }
      }
    },
    {
      title: (
        <Tooltip title="Status">
          <span>Status</span>
        </Tooltip>
      ),
      dataIndex: 'task_status',
      key: 'status'
    },
    {
      title: (
        <Tooltip title="Modified Date">
          <span>Modified</span>
        </Tooltip>
      ),
      dataIndex: 'modifiedDate',
      key: 'modifiedDate',
      render: (date) => new Date(date).toLocaleDateString() 
    },
  ];
  

  return (
    <div className='completedTaskData'>
      <div className="border-b border-gray-d-200 dark:border-white flex justify-between">
          <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 dark:text-white">
             Welcome {(auth.profile_name !== 'null') ? auth.profile_name : auth.profile_username} - Assign to a reviewer
          </h2>
      </div>
      <div className="max-w-[650px] mx-auto mt-11">
        <CustomListBox
          name="assignedTo"
          options={reviewerList}
          selectedValue={assignedTo}
          onChange={(e) => setAssignedTo(e.target.value)}
          valueKey="profile_id"
          displayKey="profile_username"
          placeholder="Select Reviewer"
        />
      </div>
      {hasSelected && <div className=' flex justify-between items-center'>
        {hasSelected ? `Selected ${selectedRowKeys.length} items` : ''}
        <button
          type="button"
          onClick={handleTaskSubmit}
          disabled={!hasSelected || !assignedTo}
          className={clsx(
            "w-[150px] h-[40px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 mb-[20px] mt-[20px]",
            {
              "bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]":
                hasSelected && assignedTo,
              "bg-gray-400 cursor-not-allowed opacity-60": !hasSelected || !assignedTo,
            }
          )}
        >
          Submit
        </button>
      </div>}
      <Table
        className="details-view-table"
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 4 }}
        rowSelection={rowSelection}
        rowKey="task_id"
      // style={{height:100}}
      />
    </div>
  );
}

export default CompletedTaskData;
